import React from "react";
import { connect } from "react-redux";

import ListForm from "./ListForm";

class Index extends React.Component<any, any> {
  render() {
    const { addAllowed, orderId, viewOnly } = this.props;
    const {
      prefix: [clientCode, storeCode],
    } = this.props;
    const disabled = viewOnly || !addAllowed;

    return (
      <div className="row" style={{ marginTop: "10px" }}>
        <div className="col-xs-12">
          <span
            className="bold"
            style={{ paddingTop: "16px", display: "inline-block" }}
          >
            Schedule Order(s)
          </span>
          <span className="pull-right">
            <a
              className={`sn-btn sn-btn-sm sn-btn-teal${disabled ? " disabled" : ""}`}
              href={
                !disabled &&
                `/${clientCode}/${storeCode}/crm/schedules/new?order_id=${orderId}&order=true`
              }
            >
              Add
            </a>
          </span>
        </div>
        <div className="col-xs-12 scrolled-row">
          <ListForm
            clientCode={clientCode}
            orderId={orderId}
            storeCode={storeCode}
            viewOnly={viewOnly}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any, _props: any) => ({
  addAllowed: state.permissions.data.order_add_schedule_order,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
